import { createExecuteWorkbenchTool } from '../domain/workbench/execute-workbench-tool.js';

/**
 * workbench-service.js
 * Calls the workbench gateway to execute tools.
 */
export class WorkbenchService {
  constructor({ workbenchGateway } = {}) {
    if (!workbenchGateway || typeof workbenchGateway.submit !== 'function') {
      throw new Error('workbenchGateway with submit() is required');
    }
    this.gateway = workbenchGateway;
    this.executeWorkbench = createExecuteWorkbenchTool({
      submit: ({ tool, teamId, teamName, payload, attachments }) =>
        this.gateway.submit({ tool, teamId, teamName, payload, attachments }),
    });
  }

  /**
   * Ask a follow-up about what a tool just produced.
   *
   * The thread is what ties it to the run; without one the server starts a new
   * one, which is the right behaviour for somebody who reloaded the page.
   */
  async askFollowup({
    toolKey,
    teamId = null,
    teamName = null,
    threadId = null,
    message = '',
    attachments = [],
  } = {}) {
    const text = String(message ?? '').trim();
    if (!text) throw new Error('Type a question first');
    return this.gateway.submitFollowup({
      tool: toolKey,
      teamId,
      teamName,
      threadId,
      message: text,
      attachments,
    });
  }

  async executeTool({
    toolKey,
    teamId = null,
    teamName = null,
    payload = {},
    attachments = [],
  } = {}) {
    return this.executeWorkbench({
      toolKey,
      teamId,
      teamName,
      payload,
      attachments,
    });
  }
}

if (typeof window !== 'undefined') {
  window.AgileProServices = window.AgileProServices || {};
  window.AgileProServices.WorkbenchService = WorkbenchService;
}
